import {
  ThermostatsRoute,
  ThermostatSchedulesRoute,
  ThermostatScheduleSettingsRoute,
} from '@/Core.Service.Domain/Controls/Thermostats/Routes';
import { PowerControlsRoute } from '@/Core.Service.Domain/Controls/PowerControls/Routes';

import { DaikinThermostatsRoute } from '@/Core.Service.Domain/Controls/DaikinThermostats/Routes';

import {
  DigitalTwinRoute,
  DigitalTwinMVPRoute,
  DigitalTwinMVPManagementRoute,
  DigitalTwinMVPAdminIndexRoute,
} from '@/Core.Service.Domain/Controls/DigitalTwin/Routes';

import {
  VAVsRoute,
  EditVAVRoute,
} from '@/Core.Service.Domain/Controls/VAVs/Routes/index.ts';

import {
  AHUsRoute,
  EditAHURoute,
  AHUCardLayoutRoute,
} from '@/Core.Service.Domain/Controls/AHUs/Routes/index.ts';

import {
  ChillersRoute,
  EditChillerRoute,
} from '@/Core.Service.Domain/Controls/Chillers/Routes';

import Edit from '@/modules/controls/_components/Edit';

import ControlsView from '@/Core.Service.Domain/Controls/Controls.Common/Views';

const routesList = [];

const ControlsRoute = {
  path: '/controls',
  name: 'Controls',
  children: [
    ThermostatsRoute,
    ThermostatSchedulesRoute,
    ThermostatScheduleSettingsRoute,
    PowerControlsRoute,
    DaikinThermostatsRoute,
    DigitalTwinRoute,
    DigitalTwinMVPRoute,
    DigitalTwinMVPManagementRoute,
    DigitalTwinMVPAdminIndexRoute,
    AHUsRoute,
    EditAHURoute,
    AHUCardLayoutRoute,
    VAVsRoute,
    EditVAVRoute,
    ChillersRoute,
    EditChillerRoute,
  ],
  component: ControlsView,
  meta: { permission: 'controls:read' },
};

const ControlsEditRoute = {
  path: '/controls/:type/:controlId',
  name: 'ControlsEdit',
  component: Edit,
};

routesList.push(ControlsRoute, ControlsEditRoute);

export default routesList;
